<template>
  <div>
    <div>
      <Navigation />
    </div>
    <div v-if="loading" class="loader-container">
      <PulseLoader size="20px" color="#3467D5" />
    </div>
    <div v-else class="cards-section">
    <div class="cards-collection">
      <div
        v-for="(service, index) in services"
        :key="index"
        @click="navigateToUser(service.servicesID, service.userID , service.servicesName)"
        class="cards"
      >
        <div class="card-headers">
          <div class="header-content">
            <div class="user-name">
              <p class="card-heading">
                {{ truncate(service.servicesName, 23) }}
              </p>
            </div>
          </div>
          <div class="actions" style="display: flex; align-items: center; ">
            <!-- Favorite Heart Icon -->
            <span
              class="heart-icon"
              :class="{ favorited: service.favorites }"
              @click.stop="toggleFavorite(service)"
              title="Add to favorites"
            >
              <svg width="24" height="24" viewBox="0 0 24 24">
                <path
                  :fill="service.favorites ? 'red' : '#bbb'"
                  d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 
                     4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 
                     14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 
                     6.86-8.55 11.54L12 21.35z"
                />
              </svg>
            </span>
            <img src="../icons/Actions.svg" alt="actions" @click.stop="openShare(service)" />
          </div>
        </div>
        <div class="card-img">
          <img
            :src="service.imageUrl ? service.imageUrl : defaultDP"
            alt="room images"
          />
        </div>

        <div class="card-details profile-img-clickable" @click.stop="goToBusinessProfile(service)">
          <div class="profile-img">
            <img :src="profileImageMap[service.userID] || defaultDP" alt="User profile" />
          </div>

          <div class="card-title">
            <div class="user-row">
              <router-link
                :to="'/business/' + getProfileSlug(service)"
                class="card-heading card-heading--link"
                @click.stop
              >
                {{ service.userDetails?.userName || "Unknown user" }}
              </router-link>
              <!-- <span
  v-if="service.userDetails && (service.userDetails.emailVerified === true || service.userDetails.phoneVerified === true)"
  class="verify-tick"
  title="Verified Account"
  style="margin-left:4px; display:inline-flex; align-items:center; vertical-align:middle;"
>
 <svg width="1em" height="1em" viewBox="0 0 24 24" style="display:block;" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" fill="#2196F3"/>
    <path d="M9.5 12.5l2 2 4-4" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <circle cx="12" cy="12" r="9.2" stroke="#1976D2" stroke-width="1.6" fill="none"/>
  </svg>
</span> -->
    <span
                v-if="service.userDetails && (service.userDetails.emailVerified === true || service.userDetails.phoneVerified === true)"
                class="verify-tick"
                title="Verified Account"
              >
               <svg width="26" height="26" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" style="display:block;">
                   <rect x="8" y="20" width="48" height="28" rx="4" fill="#E74C3C"/>
                   <polygon points="32,38 8,20 56,20" fill="#C0392B"/>
                   <polygon points="32,38 8,48 8,20" fill="#000" opacity="0.07"/>
                   <polygon points="32,38 56,48 56,20" fill="#000" opacity="0.07"/>
                   <circle cx="32" cy="20" r="12" fill="#ECECEC"/>
                   <circle cx="32" cy="20" r="8" fill="#26A69A"/>
                   <path d="M29 20l3 3 5-5" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                 </svg>
              </span>           
</div>
          </div>

          <!-- <div class="card-servicetype">
            <p>{{ service.serviceType1 || "N/A" }}</p>
          </div> -->
          <div class="card-servicetype">
  <p
    class="no-pointer"
    :title="'service type'"
  >
    {{ service.serviceType1 || "Service" }}
  </p>
</div>

        </div>
        <div class="add-details">
            <p class="card-desc">
              {{
                service.Description
                  ? truncate(service.Description, 40)
                  : "No description available"
              }}
            </p>
        </div>

        <div class="card-detail">
          <div class="info-row">
            <div class="info-item">
              <img src="../icons/locIcon.svg" alt="location" />
              <p>{{ service.location || "No location" }}</p>
            </div>
          </div>

          <div class="info-row" v-if="isvalid">
            <div class="info-item">
              <img src="../icons/callIcon.svg" alt="phone" />
              <p>{{ service.Phone || "+1 347-309-5344" }}</p>
            </div>
          </div>
           <div
          class="locationName"
          v-else
          @click.stop="openUserModal(service)"
          style="cursor: pointer; display: flex; align-items: center; gap: 8px;"
        >
          <img src="../icons/callIcon.svg" alt="phone" style="width: 20px; height: 20px;" />
          <span>View contact/email</span>
        </div>
        </div>

        <!-- Button -->
        <div class="card-btn">
          <button class="outline" @click.stop="handleSendResponse(service, $event)">
            Send Response
          </button>
        </div>
      </div>
    </div>
    <div v-if="showShare" class="share-overlay" @click.self="showShare = false">
      <div class="share-box">
        <button class="close-btn" @click="showShare = false">×</button>
        <h3>Share this Post</h3>
        <div class="share-options">
          <div class="share-item" @click.stop="shareWhatsApp(selectedService)">
            <i class="fab fa-whatsapp"></i>
            <span>WhatsApp</span>
          </div>
          <div class="share-item" @click.stop="shareTwitter(selectedService)">
            <i class="fab fa-twitter"></i>
            <span>Twitter (X)</span>
          </div>
          <div class="share-item" @click.stop="shareFacebook(selectedService)">
            <i class="fab fa-facebook-f"></i>
            <span>Facebook</span>
          </div>
          <div class="share-item" @click.stop="shareEmail(selectedService)">
            <i class="fas fa-envelope"></i>
            <span>Email</span>
          </div>
          <div class="share-item" @click.stop="shareInstagram(selectedService)">
            <i class="fab fa-instagram"></i>
            <span>Instagram</span>
          </div>
          <div class="share-item" @click.stop="copyLink(selectedService)">
            <i class="fas fa-link"></i>
            <span>Copy Link</span>
          </div>
        </div>
      </div>
    </div>
 <AuthModal
  v-if="showLogin"
  :mode="authMode"
  @switchMode="switchMode"
  @close="closeLogin"
/>
    <FloatingView
  v-if="showFloating && selectedService"
  :service="selectedService"
  @close="closeFloating"
/>
  </div>
    <div>

      <FooterSection />
    </div>
  </div>
</template>

<script>

import FloatingView from "../pages/SendResponse.vue";
import { WEB_ORIGIN } from "@/config/apiBase";
import axios from "axios";
import defaultDP from "../icons/Avatar.svg";
import DefaultImage from "../icons/cardFrame.png";          
import userDetailsServices from "../../services/userDetailsService";
import AuthModal from "./Models/AuthModal.vue";
import { toast } from "vue-sonner";
import Navigation from './Navigation.vue';
import FooterSection from './footer.vue';
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { trackEvent } from "@/composables/useAnalytics";
import { canonicalSlug } from "@/utils/slug";

export default {
  components: {
    FloatingView,
    AuthModal,
    Navigation,
    FooterSection,
    DefaultImage,
      PulseLoader,
  },
  data() {
    return {
      showFloating: false,
      selectedService: null,
      isvalid: null,
      profileImageMap: {},
      defaultDP,
      DefaultImage,
      // Add services array for reactivity
      services: [],
      loading: true,

      // CORRECT modal flags
      showLogin: false,
      authMode: "login",
      showUserModal: false, 
      showShare: false,
      selectedService: null,
      shareUrl: window.location.href,
      copiedLink: '',
    };
  },

watch: {
  services: {
    immediate: true,
    handler(newServices) {
      if (!newServices || newServices.length === 0) return;

      newServices.forEach(async (srv, idx) => {
        // Set default favorites to false if not present (Vue 3: direct assignment)
        if (srv.favorites === undefined) {
          srv.favorites = false;
        }
        const userId = srv.userID;

        // Set default profile image immediately
        this.profileImageMap = { 
          ...this.profileImageMap, 
          [userId]: this.defaultDP 
        };

        // Fetch real image
        const imgUrl = await userDetailsServices.getProfileImage(userId);
        this.profileImageMap = { 
          ...this.profileImageMap, 
          [userId]: imgUrl || this.defaultDP 
        };

        // Fetch verification status and update userDetails
        if (!srv.userDetails) srv.userDetails = {};
        try {
          const verRes = await userDetailsServices.getVerificationStatus(userId);
          const updatedService = {
            ...srv,
            userDetails: {
              ...srv.userDetails,
              emailVerified: verRes?.data?.item?.emailVerified === true,
              phoneVerified: verRes?.data?.item?.phoneVerified === true,
            }
          };
          this.services[idx] = updatedService;
        } catch (e) {
          const updatedService = {
            ...srv,
            userDetails: {
              ...srv.userDetails,
              emailVerified: false,
              phoneVerified: false,
            }
          };
          this.services[idx] = updatedService;
        }
      });
    },
  },
},


  
  mounted() {
     this.favServices();
     const token = localStorage.getItem("auth-token");
    // Guest (no token): asking the server would 401 with "Invalid or expired
    // token", which the global interceptor treats as an expired session and
    // shows the "session expired" banner to a user who never signed in.
    if (!token) {
      this.isvalid = false;
      return;
    }
    axios
      .post(
        "/api/verify-token",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      )
      .then(() => {
        this.isvalid = true;
      })
      .catch(() => {
        this.isvalid = false;
      });

   
  },
  methods: {
       getProfileSlug(service) {
      const userName = service?.userDetails?.userName;
      const userId = service?.userID;
      return userName
        ? userName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
        : userId || '';
    },
    goToBusinessProfile(service) {
      const userId = service?.userID;
      if (!userId) return;
      const slug = this.getProfileSlug(service);
      this.$router.push({ name: 'BusinessProfile', params: { slug } });
    },
    async favServices() {
      try {
          this.loading = true;
        const response = await axios.post("/api/servicescustom", { favorites: true });
        let services = response.data.items || [];
        console.log("Fetched favorite services:", services);
        services = services.map((s) => ({
          ...s,
          imageUrl:
            s.serviceImages && s.serviceImages.length > 0 && s.serviceImages[0].url && typeof s.serviceImages[0].url === 'string' && s.serviceImages[0].url.trim() !== ''
              ? s.serviceImages[0].url
              : this.DefaultImage,
        }));
        this.services = services;
      } catch (err) {
        console.error("Failed to fetch favorite services", err);
        this.services = [];
      }
      finally {
    this.loading = false; 
  }
    },
    // Use service.favorites directly for color
    async toggleFavorite(service) {
      try {
        // Toggle favorites value
        const newStatus = !service.favorites;
        await axios.put('/api/services', {
          servicesID: service.servicesID,
          favorites: newStatus
        });
        service.favorites = newStatus;
        // Show toast/alert
        if (newStatus) {
          trackEvent('add_to_favorite', { post_id: service.servicesID });
          toast.success('Added to favorites!');
        } else {
          trackEvent('remove_favorite', { post_id: service.servicesID });
          toast.info('Removed from favorites!');
        }
      } catch (err) {
        console.error('Failed to update favorite status', err);

      }
    },
    goToBusinessProfile(service) {
      const userId = service?.userID;
      if (!userId) return;
      const userName = service?.userDetails?.userName;
      const slug = userName
        ? userName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
        : userId;
      this.$router.push({ name: 'BusinessProfile', params: { slug } });
    },
    truncate(text, length) {
      if (!text) return "";
      return text.length > length ? text.substring(0, length) + "..." : text;
    },
    async navigateToUser(servicesID, userID, servicesName) {
      localStorage.setItem(
        "viewPostContext",
        JSON.stringify({
          servicesID,
          userID,
          from: "favorites",
        })
      );

      // The stored slug is the only one guaranteed to resolve, so it's used
      // verbatim — a "+N" duplicate-title suffix must survive untouched.
      let url = null;
      try {
        const res = await axios.post("/api/serviceslinklist", {
          serviceID: servicesID,
        });
        if (res.data && res.data.items && res.data.items[0] && res.data.items[0].url) {
          url = res.data.items[0].url;
        }
      } catch (err) {
       console.warn("Error fetching service link:", err);
      }
      // Always navigate; derive the slug from the title only if the lookup
      // failed, using the same rule that created it (see utils/slug.js).
      this.$router.push({
        name: "view-post",
        params: {
          serviceName: url || canonicalSlug(servicesName),
        },
      });
    },
handleSendResponse(service) {
  if (this.isvalid) {
    this.openFloating(service);
  } else {
    this.authMode = "login";
    this.showLogin = true;
    localStorage.setItem("redirectTo", this.$route.fullPath);
  }
},


openUserModal(service) {
  if (!this.isvalid) {
    this.authMode = "login";
    this.showLogin = true;
    return;
  }

  this.selectedService = service;
  this.showUserModal = true;
},

   openFloating(service) {
  this.selectedService = service;
  this.showFloating = true;
},
     closeFloating() {
      this.showFloating = false;
      this.selectedService = null;
    },


    switchMode(mode) {
    this.authMode = mode;
  },

    
  closeLogin() {
    this.showLogin = false;
  },

    async getServiceUrl(service) {
      if (!service) return window.location.href;
      let url = WEB_ORIGIN + "/view-post/";
      try {
        const res = await axios.post("/api/serviceslinklist", { serviceID: service.servicesID });
        if (res.data && res.data.items && res.data.items[0] && res.data.items[0].url) {
          url += res.data.items[0].url;
        } else {
          url += canonicalSlug(service.servicesName);
        }
      } catch (e) {
        url += canonicalSlug(service.servicesName);
      }
      return url;
    },
    async shareWhatsApp(service) {
      const url = await this.getServiceUrl(service);
      window.open(`https://wa.me/?text=${encodeURIComponent(url)}`, "_blank");
    },
    async shareTwitter(service) {
      const url = await this.getServiceUrl(service);
      window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`, "_blank");
    },
    async shareFacebook(service) {
      const url = await this.getServiceUrl(service);
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, "_blank");
    },
    async shareEmail(service) {
      const url = await this.getServiceUrl(service);
      window.location.href = `mailto:?subject=Check this out&body=${encodeURIComponent(url)}`;
    },
    shareInstagram() {
      // Open the specified Instagram page directly
      window.open("https://www.instagram.com/renants_classifieds/", "_blank");
    },
    openShare(service) {
      this.selectedService = service;
      this.showShare = true;
    },
    async copyLink(service) {
      const url = await this.getServiceUrl(service);
      try {
        await navigator.clipboard.writeText(url);
        this.copiedLink = url;
        toast.success("Link copied to clipboard!");
      } catch (e) {
        toast.error("Failed to copy link");
      }
    },


  },
};
</script>

<style scoped>
 /* Heart icon styles */
 .loader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
    .heart-icon {
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      transition: transform 0.1s;
      margin-right: 2px;
    }
    .heart-icon svg {
      display: block;
    }
    .heart-icon.favorited svg path {
      fill: 	#DC143C;
    }
    .heart-icon:active {
      transform: scale(1.2);
    }
.add-details{
   padding-left:16px;
    padding-bottom: 10px;
}
.locationName {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* height: 17px; */
  align-items: center;
  font-family : var(--font-primary);
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  /* line-height: 17px; */
  color: var(--color-primary-dark);
  flex: none;
  order: 0;
  flex-grow: 0;
  /* padding-bottom: 30px; */

 
}
.cards-section {
  width: 100%;
  max-width: 1280px;
  margin: 24px auto;
  /* padding: 0 32px;            */
  box-sizing: border-box;
}

.cards-collection {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 0 24px;
  justify-content: flex-start;
}

.cards {
  flex: 1 1 calc(33.333% - 24px);
  max-width: 390px;
  border: 1px solid var(--color-border-light);
  border-radius: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background: var(--color-bg-primary);
  overflow: hidden;
  cursor: pointer;
}

.card-headers {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 10px;
  box-sizing: border-box;
  /* gap: 5px; */
}

.profile-img {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  padding: 2px; /* border thickness */
  background: var(--color-primary-gradient);

  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-img img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  background: var(--color-bg-primary);
}

.card-detail {
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 0px 16px 24px 16px;
  box-sizing: border-box;
}

.info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-item img {
  width: 24px;
  height: 24px;
}

.info-item p {
  margin: 0;
  font-family: var(--font-primary), sans-serif;
  font-size: 14px;
  color: var(--color-text-primary);
  font-weight: 600;
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.header-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.user-name {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-right: 16px;
}

.user-name p {
  font-family: var(--font-primary), sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: var(--color-text-primary);
  margin: 0;
}

.badge {
  width: 14px;
  height: 14px;
}

.time {
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  color: var(--color-text-primary);
  font-weight: 400;
  line-height: 18px;
}

.actions img {
  width: 30px;
  height: 30px;
  cursor: pointer;
  padding: 4px;
}

.card-img {
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
  /* Reserve space for image to prevent CLS */
  aspect-ratio: 16 / 9;
  overflow: hidden;
}

.card-img img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
  display: block;
}

.card-details {
  display: flex;
  justify-content: space-between;
  padding: 16px 16px 0px 16px;
  box-sizing: border-box;
  align-items: flex-start;
  gap: 8px;
}

.card-title {
  flex: 1;
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
  overflow: hidden;
}

.card-heading {
  font-family: var(--font-primary), sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 30px;
  color: var(--color-text-primary);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-desc {
  font-family: var(--font-primary), sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--color-text-secondary);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-servicetype {
  flex-shrink: 0;
  border-radius: 2px;
  border: 0.77px solid transparent;
  background: linear-gradient(white, white) padding-box,
    var(--color-primary-gradient) border-box;
  /* margin-right: 16px; */
  height: 28.3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 120px;
}

.card-servicetype p {
  font-family: var(--font-primary), sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  padding: 3.5px 10.77px;
  margin: 0;
  border-radius: 4px;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  background-image: var(--color-primary-gradient);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 1280px) {
  .cards {
    flex: 1 1 calc(45% - 24px);
    max-width: 340px;
  }
    .card-detail {
    display: flex;
    flex-direction: column;
    width:100%;
  

  }
   .cards-collection {

  justify-content: center;
}
  
}

@media (max-width: 768px) {
  .cards {
    flex: 1 1 100%;
    max-width: 100%;
  }
  .card-detail {
    display: flex;
    flex-direction: column;
    width:100%;
  }
  .cards-collection {

  justify-content: center;
}
}


.share-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.no-pointer {
  cursor: default; 
}


.share-box {
  position: relative; /* needed for close button positioning */
  background: var(--color-bg-primary);
  padding: 25px;
  width: 340px;
  border-radius: 18px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.15);
  animation: popupShow 0.25s ease;
}


@keyframes popupShow {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.share-box h3 {
  margin-bottom: 15px;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}

.share-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.share-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid var(--color-border-light);
  border-radius: 10px;
  cursor: pointer;
  transition: 0.2s;
}

.share-item:hover {
  background: var(--color-bg-secondary);
  transform: translateY(-2px);
}

.share-item img {
  width: 26px;
  height: 26px;
}

.close-btn {
  position: absolute;
 
  right: 05px;
  width: 32px;
  height: 32px;
  padding: 0;
  color: var(--color-text-primary);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
  line-height: 32px;
  text-align: center;
  z-index: 10; /* ensure it’s above other content */
}

.share-item i {
  font-size: 24px;
  margin-right: 8px;
  color: var(--color-text-secondary);
}

.share-item span{
    font-family: var(--font-primary);
  font-weight: 500;
  font-size: 14px; 
  text-align: center;
  color: var(--color-text-primary);
}
.user-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

/* .verify-tick {
  width: 1em;
  height: 1em;
  margin-left: 4px;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
} */

.card-heading {
  font-family: var(--font-primary), sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 30px;
  color: var(--color-text-primary);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-heading--link {
  text-decoration: none;
  color: var(--color-text-primary);
  transition: color 0.2s;
  display: block;
}
.card-heading--link:hover {
  color: #0d9488;
  text-decoration: underline;
}
</style>